var SITE_ROOT = "https://advisersdev.wealthdesk.in/";
var SITE_NAME = "Adviser Micro Website";
//WD API
var API_ROOT_URL = "https://testing.wealthtech.in/investor/";
var API_ROOT_KEY = 'KiWsv89Ac14Zl6bnniJJP9bKdBGOPEvl9QlJoZR2';
var GATEWAY_API_ROOT_URL = "https://testing.wealthtech.in/gateway/";
var GATEWAY_API_ROOT_KEY = "KiWsv89Ac14Zl6bnniJJP9bKdBGOPEvl9QlJoZR2";
var BUSINESS_API_ROOT_URL = "https://businessapisuat.wealthdesk.in/";
var BUSINESS_API_ROOT_KEY = "BYsZfJWr8m4MgflbCcb4N8yy9L1ij3VGaKKYbsMc";

var SIGNDESK_SDK_URL = 'https://signdesk.in/api/eSignWidgetUat.js';
var ENACH_SDK_URL = 'https://www.paynimo.com/Paynimocheckout/server/lib/checkout.js';
//BROKER API
var BROKER_API_ROOT = '';
var BROKER_API_KEY = '';
var BROKER_DEPLOYMENT_ID = 'dev';
var BROKER_WD_NAME = 'WD';
var BROKER_COMPANY_NAME = 'WD Virtual Pvt Ltd';
var SHOW_KYC_PAGE = true;
var SHOW_RISK_PROFILE_SECTION = false;
var BROKER_ORDERING = ['ZERODHA', 'UPSTOX', 'ICICIDIRECT', 'MOSL'];
//QC API
var QC_API_URL = 'https://api.openq.in/fb_prod/';
var QC_API_KEY = 'TRjT6NOOmI5DZFgUBRwem7d4jlxY4EQp366QR9in';
var QC_ANALYZER_URL = 'https://openq.in';
var ANALYZER_SWITCH = false;
var ADVISERS_SUBDOMAIN_MAP = {
    quantech: "openq",
    anubhav: "aver",
    plutuscapital: "plutuscapital",
    sonamsrivastava: "wrightresearch",
    wealthvruddhi: "finmo",
    wealthyvia: "wealthyvia",
    jarvis: "jarvisinvest",
    valuestocks: "valuestocks",
    AlgoSmith: "AlgoSmith",
	tamohara: "tamohara",
	renaissanceinvest: "alphaportfolios",
    abakkus: "abakkus",
    alokjain: "weekendinvesting",
    siddharthvora: "plindia",
	pmsbazaar: "myalternates",
    finnovators: "finnovators",
    sapient: "sapient",
    flipitnews: "flipitnews",
    tradenet: "tradenet",
    aifpms: "aifpms",
    bridgeweave: "investorai",
    smartbox: "smartbox",
    Kotak_Cherry: "kotak-cherry"
}
var GTM_TRACKING_ID = {
    "abc": "GTM-abc"
};
var CONTENT_TYPE = 'application/json';
var CHAT_WIDGET_ENABLED = true;
var INVESTING_MODE = 'REAL';
// BROKERS METADATA
var BROKERS = ['BPWEALTH', 'IIFLSEC', 'UPSTOX', 'MOSL', "ZERODHA", "ADITYABIRLA", "ICICIDIRECT"];
var OFFLINE_BROKERS = ['DYNAMICEQUITIES', 'WD', 'SHAREKHAN', 'ANGELBROKING', 'CHOICEBROKING', 'GEOJIT', 'HEM', 'FIVEPAISA', 'ALICEBLUE', 'EDELWEISS', 'HDFCSEC', 'KOTAKSEC', 'TRUSTLINE'];
var ODINBROKERS = ['RMONEY', 'PRABHUDAS', 'ASTHA', 'ARIHANT', 'NORTHEAST', 'RELIGARE', 'PESB', 'SUSHILFIN', 'MAVERICK'];
var BPWEALTH = {
    logoUrl: 'assets/img/bp-logo-small.png',
    brokerPage: 'https://wealthdesk.bpwealth.com/broker-login',
    orderPlacementUrl: 'https://wealthdesk.bpwealth.com/order-placement',
    brokerName: 'BP Wealth'
};
var ICICIDIRECT = {
    logoUrl: 'assets/img/icici-direct-logo.png',
    brokerPage: 'https://icicidirect.wealthdesk.in/broker-login',
    orderPlacementUrl: 'https://icicidirect.wealthdesk.in/order-placement',
    brokerName: 'ICICI Direct'
};
var MOSL = {
    logoUrl: 'assets/img/mosl-logo-small.png',
    brokerPage: 'https://wealthdesk.motilaloswal.com/broker-login',
    orderPlacementUrl: 'https://wealthdesk.motilaloswal.com/order-placement',
    brokerName: 'Motilal Oswal'
};
var ZERODHA = {
    logoUrl: 'assets/img/zerodha-logo-small.png',
    brokerPage: 'https://zerodha.wealthdesk.in/broker-login',
    orderPlacementUrl: 'https://zerodha.wealthdesk.in/order-placement',
    brokerName: 'Zerodha'
};
var UPSTOX = {
    logoUrl: 'assets/img/upstox-logo-small.png',
    brokerPage: 'https://upstox.wealthdesk.in/broker-login',
    orderPlacementUrl: 'https://upstox.wealthdesk.in/order-placement',
    brokerName: 'Upstox'
};
var WD = {
    logoUrl: 'assets/img/other-broker-logo-small.png',
    brokerPage: '/register-client',
    holdingsPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'Other Brokers'
};
var FIVEPAISA = {
    logoUrl: 'assets/img/fivepaisa-logo.png',
    brokerPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'Five Paisa'
};
var ALICEBLUE = {
    logoUrl: 'assets/img/aliceblue-logo.png',
    brokerPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'Alice Blue'
};
var EDELWEISS = {
    logoUrl: 'assets/img/edelweiss-logo.png',
    brokerPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'Edelweiss'
};
var HDFCSEC = {
    logoUrl: 'assets/img/hdfcsec-logo.png',
    brokerPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'HDFC Securities'
};
var IIFLSEC = {
    logoUrl: 'assets/img/iiflsec-logo.png',
    brokerPage: 'https://wealthdesk.indiainfoline.com/broker-login',
    orderPlacementUrl: 'https://wealthdesk.indiainfoline.com/order-placement',
    brokerName: 'IIFL Securities'
};
var ADITYABIRLA = {
    logoUrl: 'assets/img/adityabirla-logo.png',
    brokerPage: 'https://wealthdesk.adityabirlamoney.com/broker-login',
    orderPlacementUrl: 'https://wealthdesk.adityabirlamoney.com/order-placement',
    brokerName: 'Aditya Birla'
};
var KOTAKSEC = {
    logoUrl: 'assets/img/kotaksec-logo.png',
    brokerPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'Kotak Securities'
};
var TRUSTLINE = {
    logoUrl: 'assets/img/trustline-logo.png',
    brokerPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'Trustline'
};
var SHAREKHAN = {
    brokerPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'ShareKhan'
};
var ANGELBROKING = {
    brokerPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'Angel Broking'
};
var CHOICEBROKING = {
    brokerPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'Choice Broking'
};
var GEOJIT = {
    brokerPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'GEOJIT'
};
var DYNAMICEQUITIES = {
    brokerPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'Dynamic Equities'
};
var HEM = {
    brokerPage: '/register-client',
    orderPlacementUrl: '/order-placement',
    brokerName: 'HEM'
};
var RMONEY = {
    logoUrl: 'assets/img/rmoney-logo.png',
    brokerPage: 'https://wealthdesk.rmoneyindia.com/broker-login',
    orderPlacementUrl: 'https://wealthdesk.rmoneyindia.com/order-placement',
    brokerName: 'R Money'
};
var PRABHUDAS = {
    logoUrl: 'assets/img/plindia-logo.png',
    brokerPage: 'https://wealthdesk.plindia.com/broker-login',
    orderPlacementUrl: 'https://wealthdesk.plindia.com/order-placement',
    brokerName: 'Prabhudas Lilladher'
};
var ASTHA = {
    logoUrl: 'assets/img/astha-logo.svg',
    brokerPage: 'https://wealthdesk.asthatrade.com/broker-login',
    orderPlacementUrl: 'https://wealthdesk.asthatrade.com/order-placement',
    brokerName: 'Astha Trade'
};
var ARIHANT = {
    logoUrl: 'assets/img/arihantcapital-logo.jpg',
    brokerPage: 'https://arihantcapital.wealthdesk.in/broker-login',
    orderPlacementUrl: 'https://arihantcapital.wealthdesk.in/order-placement',
    brokerName: 'Arihant Capital'
};
var NORTHEAST = {
    logoUrl: 'assets/img/northeast-logo.png',
    brokerPage: 'https://northeastltd.wealthdesk.in/broker-login',
    orderPlacementUrl: 'https://northeastltd.wealthdesk.in/order-placement',
    brokerName: 'Northeast Ltd'
};
var MAVERICK = {
    logoUrl: 'https://fund-icon-aprod.s3.amazonaws.com/maverick-logo.png',
    brokerPage: 'https://maverick.wealthdesk.in/broker-login',
    orderPlacementUrl: 'https://maverick.wealthdesk.in/order-placement',
    brokerName: 'Maverick'
};
var RELIGARE = {
    logoUrl: 'https://fund-icon-aprod.s3.amazonaws.com/religare-logo.png',
    brokerPage: 'https://religare.wealthdesk.in/broker-login',
    orderPlacementUrl: 'https://religare.wealthdesk.in/order-placement',
    brokerName: 'Religare'
};
var PESB = {
    logoUrl: 'assets/img/pesb-logo.jpg',
    brokerPage: 'https://pesb.wealthdesk.in/broker-login',
    orderPlacementUrl: 'https://pesb.wealthdesk.in/order-placement',
    brokerName: 'PUNE e STOCK'
};
var SUSHILFIN = {
    logoUrl: 'assets/img/sushilfin-logo.png',
    brokerPage: 'https://wealthdesk.sushilfinance.com/broker-login',
    orderPlacementUrl: 'https://wealthdesk.sushilfinance.com/order-placement',
    brokerName: 'Sushil Finance'
};
//Advisers MetaData for Microsites
var IS_PAYMENTS_ENABLED = true;
var PAYTM_URL = 'https://securegw-stage.paytm.in/order/process';
var CALLBACK_URL = 'payment';
var CHANNEL_ID = 'WEB';
var WEALTHTECH_MID = '';
var INDUSTRY_TYPE_ID = 'Retail';
var WEBSITE = 'WEBSTAGING';
var ADVISERSMETADATA = {
    quantech: {
        subdomain: "advisersdev",
        webadminName: "wdwebadmin2",
        type: "adviser",
        kycFetchApi: true,
        hideEntityDetails: false,
        isEsignEnabled: true,
        isEsignFallBackDisabled: false,
        eNachEnabled: true,
        paytmDisabled: false,
        productName: 'Smart Beta WealthBasket',
        faqUrl: 'https://s3.ap-south-1.amazonaws.com/wdpages/openqfaqs.json',
        header2: 'Conventional Wisdom says making market beating returns over long period of time is not possible. We disagree. There always exist specific pockets of opportunities which when captured systematically through data driven process',
        homePagetitle: 'OpenQ: Sebi Registered Investment Advisor',
        discoverPageTitle: 'OpenQ Smart Beta WealthBaskets: Stock & ETF SmartBeta Portfolios',
        faqPageTitle: 'OpenQ WealthBaskets FAQs Page',
        contactPageTitle: 'Contact OpenQ | Quantech Capital',
        contactPageDesc: 'Contact us for any support on WealthDesk and WealthDesk Business platform.',
        homePageDesc: 'OpenQ is Sebi Registered Investment Advisor that offers smart beta portfolios and other investment tools like portfolio scanner and optimiser.',
        discoverPageDesc: 'OpenQ Smart Beta WealthBaskets are Stock and ETF portfolios based on Value, Size, Quality, Momentum, Dividend Yield and Volatility.',
        faqDesc: 'Frequently asked questions on the OpenQ Smart Beta WealthBaskets platform and their answers can be found here.'
    }
}
app.value('config', {
    API_ROOT_URL: API_ROOT_URL,
    API_ROOT_KEY: API_ROOT_KEY,
    GATEWAY_API_ROOT_URL:GATEWAY_API_ROOT_URL,
    GATEWAY_API_ROOT_KEY:GATEWAY_API_ROOT_KEY,
    BUSINESS_API_ROOT_URL: BUSINESS_API_ROOT_URL,
    BUSINESS_API_ROOT_KEY: BUSINESS_API_ROOT_KEY,
    BROKER_API_ROOT: BROKER_API_ROOT,
    BROKER_API_KEY: BROKER_API_KEY,
    BROKER_COMPANY_NAME: BROKER_COMPANY_NAME,
    BROKER_DEPLOYMENT_ID: BROKER_DEPLOYMENT_ID.toLowerCase(),
    BROKER_WD_NAME: BROKER_WD_NAME.toUpperCase(),
    BROKER_ORDERING: BROKER_ORDERING,
    INVESTING_MODE: INVESTING_MODE.toUpperCase(),
    CONTENT_TYPE: CONTENT_TYPE,
    BROKERS: BROKERS,
    ODINBROKERS: ODINBROKERS,
    BPWEALTH: BPWEALTH,
    ZERODHA: ZERODHA,
    UPSTOX: UPSTOX,
    WD: WD,
    MOSL: MOSL,
    OFFLINE_BROKERS: OFFLINE_BROKERS,
    FIVEPAISA: FIVEPAISA,
    ALICEBLUE: ALICEBLUE,
    EDELWEISS: EDELWEISS,
    DYNAMICEQUITIES: DYNAMICEQUITIES,
    HDFCSEC: HDFCSEC,
    IIFLSEC: IIFLSEC,
	ADITYABIRLA: ADITYABIRLA,
    KOTAKSEC: KOTAKSEC,
    TRUSTLINE: TRUSTLINE,
    SHAREKHAN: SHAREKHAN,
    ICICIDIRECT: ICICIDIRECT,
    ANGELBROKING: ANGELBROKING,
    CHOICEBROKING: CHOICEBROKING,
    GEOJIT: GEOJIT,
    RELIGARE: RELIGARE,
    MAVERICK: MAVERICK,
    HEM: HEM,
    RMONEY: RMONEY,
    PRABHUDAS: PRABHUDAS,
    ASTHA: ASTHA,
    ARIHANT: ARIHANT,
    NORTHEAST: NORTHEAST,
    PESB: PESB,
	SUSHILFIN: SUSHILFIN,
    SHOW_KYC_PAGE: SHOW_KYC_PAGE,
    SHOW_RISK_PROFILE_SECTION: SHOW_RISK_PROFILE_SECTION,
    QC_API_URL: QC_API_URL,
    QC_API_KEY: QC_API_KEY,
    PAYTM_URL: PAYTM_URL,
    CALLBACK_URL: CALLBACK_URL,
    CHANNEL_ID: CHANNEL_ID,
    WEALTHTECH_MID: WEALTHTECH_MID,
    INDUSTRY_TYPE_ID: INDUSTRY_TYPE_ID,
    WEBSITE: WEBSITE,
    ADVISERSMETADATA: ADVISERSMETADATA,
    QC_ANALYZER_URL: QC_ANALYZER_URL,
    ANALYZER_SWITCH: ANALYZER_SWITCH,
    ADVISERS_SUBDOMAIN_MAP: ADVISERS_SUBDOMAIN_MAP,
    SIGNDESK_SDK_URL: SIGNDESK_SDK_URL,
    ENACH_SDK_URL: ENACH_SDK_URL,
    IS_PAYMENTS_ENABLED: IS_PAYMENTS_ENABLED,
    BUSINESS_API_ROOT_URL: BUSINESS_API_ROOT_URL,
    BUSINESS_API_ROOT_KEY: BUSINESS_API_ROOT_KEY
});
